<script lang="ts">
	import type { CategoryScore } from '#lib/types';
	import { t } from '#lib/i18n/state.svelte';
	import { scoreTone, categoryLabel } from '#lib/ui/labels';

	interface Props {
		categories: CategoryScore[];
	}
	let { categories }: Props = $props();
</script>

<ul class="cats">
	{#each categories as c (c.category)}
		<li class="cat" class:unchecked={!c.checked}>
			<div class="top">
				<span class="name">
					{categoryLabel(c.category)}
					{#if !c.checked}<span class="chip chip-neutral">{t('category.notChecked')}</span>{/if}
				</span>
				<span class="score" style:color={c.checked ? scoreTone(c.score) : 'var(--muted)'}>
					{c.checked ? c.score : '—'}
				</span>
			</div>
			<div class="track" aria-hidden="true">
				<div
					class="fill"
					style:width="{c.checked ? c.score : 0}%"
					style:background={c.checked ? scoreTone(c.score) : 'var(--line-strong)'}
				></div>
			</div>
			<div class="meta">
				<span>{t('common.weight', { n: Math.round(c.weight * 100) })}</span>
				<span>
					{#if c.checked}
						{t('category.findings', { n: c.issueCount })}{#if c.criticalCount}
							· {t('category.criticals', { n: c.criticalCount })}{/if}
					{:else}
						{c.note ?? t('category.noData')}
					{/if}
				</span>
			</div>
		</li>
	{/each}
</ul>

<style>
	.cats {
		list-style: none;
		margin: 0;
		padding: 0;
		display: grid;
		gap: 0.95rem;
	}
	.cat {
		display: grid;
		gap: 0.3rem;
	}
	.cat.unchecked {
		opacity: 0.72;
	}
	.top {
		display: flex;
		align-items: baseline;
		justify-content: space-between;
		gap: 0.75rem;
	}
	.name {
		font-size: 0.86rem;
		font-weight: 550;
		display: flex;
		align-items: center;
		gap: 0.4rem;
		flex-wrap: wrap;
	}
	.score {
		font-family: var(--font-display);
		font-size: 1.35rem;
		line-height: 1;
		font-variant-numeric: tabular-nums;
	}
	.track {
		height: 6px;
		border-radius: 99px;
		background: var(--paper-2);
		overflow: hidden;
	}
	.fill {
		height: 100%;
		border-radius: inherit;
		transition: width 0.8s var(--ease);
	}
	.meta {
		display: flex;
		justify-content: space-between;
		gap: 0.5rem;
		font-size: 0.72rem;
		color: var(--muted);
	}
</style>
